import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 300,
    minHeight: 300,
    margin: [[20, 'auto']],
    width: 250,
    marginLeft: 'auto',
    marginRight: 'auto',
    [theme.breakpoints.up('sm')]: {
      margin: [[20, 'auto']],
    },
  },
  media: {
    height: 140,
    margin: 20,
    backgroundSize: 'contain',
  },
  regular: {
    fontSize: '22px',
    minHeight: 64,
  },
  dense: {
    fontSize: '22px',
    height: 64,
  }
}));

export default function CompanyCard(props) {
  const classes = useStyles();

  return (
    <Card className={classes.root} raised={true}>
      <CardActionArea onClick={() => props.click(props.company.slug)}>
        <CardMedia
          className={classes.media}
          image={props.company.logo.thumb.url}
          title={props.company.name}
        />
        <CardContent>
          <Typography gutterBottom variant="h5" component="h2" className={props.company.name.length > 20 ? classes.dense : classes.regular}>
            {props.company.name}
          </Typography>
        </CardContent>
      </CardActionArea>
      <CardActions>
        <Box display='flex' justifyContent="space-between" flexDirection="row" style={{width: '100%'}}>
          <Button style={{display:'block'}} size="small" color="primary" onClick={() => props.click(props.company.slug)}>
            Enter booth
          </Button>
          { props.company.chat_enabled ?
          <Button  style={{display:'block'}} variant="contained" size="small" color="primary" onClick={() => props.chatClick(props.company.slug)}>
            Chat now
          </Button> : <></> }
        </Box>
      </CardActions>
    </Card>
  );
}
